<template>
    <div class="block" style="background-color:#fff; text-align: right;" >
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="page"
      :page-size="10"
      layout="prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import request from '../utils/request';
export default {
    data() {
        return {
            // pageNum: 1,
            page: 1,
        }
    },
    props: {
        total:Number,
        url: String,
        goodsType: String,
        categoryId: {
            type: [Number,String]
        },
        goodsName: String,
        goodsCode: String,
    },
    methods: {
        async getList() {
            //console.log(this.categoryId,typeof(this.categoryId));
            const res = await request({
                method: "POST",
                url: "admin/commodity/warehouse/findGoods",
                data: {
                    pageNum: this.page,
                    pageSize: 10,
                    goodsType: this.goodsType,
                    categoryId: this.categoryId,
                    goodsName: this.goodsName,
                    goodsCode: this.goodsCode
                }
            })
            //console.log('子',res);
            if (res.code === '200') {
                this.$emit('pageGoods',res.data)

            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
            }
        },
      handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.page = val
        this.getList()
      }
    },
    watch: {
        categoryId: function(newval, oldval){
            if (newval != oldval) {
                this.page = 1
            }
        },
        goodsName: function(newval, oldval){
            if (newval != oldval) {
                this.page = 1
            }
        },
        goodsCode: function(newval, oldval){
            if (newval != oldval) {
                this.page = 1
            }
        },
    }
    
}
</script>